import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from 'wmic-portals-url-js';

/**
 * Service for sending logs to PolicyCenter via JSONRPC
 */
export default class WMICLoggingService {
    /**
     * Sends a log payload to PolicyCenter
     * 
     * @param {Object} logPayload - The log payload to send
     * @param {string} logPayload.level - Log level (error, warn, info, debug, log)
     * @param {string} logPayload.logCategory - Category (log, exception, xhr)
     * @param {string} logPayload.message - Log message
     * @param {Object} [logPayload.stackTrace] - Stack trace if available
     * @param {string} [logPayload.cause] - Cause of the error
     * @param {string} [logPayload.userId] - User ID
     * @param {string} [logPayload.pageName] - Page name where log occurred
     * @param {string} [logPayload.pageUrl] - Page URL
     * @param {string} [logPayload.ts] - Timestamp
     * @param {string} [logPayload.serverResponse] - Server response (for XHR errors)
     * @param {string} [logPayload.errorUrl] - Error URL (for XHR errors)
     * @param {string} [logPayload.errorMethod] - Error method (for XHR errors)
     * @param {Object} [additionalHeaders] - Additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} Promise from the backend call
     */
    static async logToPC(logPayload, additionalHeaders = {}) {
        const serviceUrl = getProxiedServiceUrl('quote');

        if (!serviceUrl) {
            return;
        }

        try {
            await JsonRPCService.send(
                serviceUrl,
                'logToPC',
                [logPayload],
                additionalHeaders
            );
        } catch (error) {
            return;
        }
    }
}
